import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1fe42e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-md-12 px-1 py-3 border-bottom"
}
const _hoisted_2 = { class: "row securities_transactions mt-4 px-3 securities_transaction_{{$fum->fum_id}}" }
const _hoisted_3 = { class: "col-md-12 table-responsive" }
const _hoisted_4 = {
  id: "exA",
  class: "table table-striped table-bordered nowrap w-100"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Date/Acquisition"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount Invested "),
    /*#__PURE__*/_createElementVNode("th", null, "Amount Returned "),
    /*#__PURE__*/_createElementVNode("th", null, "Valuation (AUM) "),
    /*#__PURE__*/_createElementVNode("th", null, "Balance"),
    /*#__PURE__*/_createElementVNode("th", null, "Profit")
  ])
], -1))
const _hoisted_6 = ["data-acqId", "id"]
const _hoisted_7 = { class: "exA" }
const _hoisted_8 = { class: "exA" }
const _hoisted_9 = { class: "exA" }
const _hoisted_10 = { class: "exA" }
const _hoisted_11 = { class: "exA" }
const _hoisted_12 = { class: "exA" }
const _hoisted_13 = { class: "row securities_transactions mt-4 px-3" }
const _hoisted_14 = { class: "col-md-12 table-responsive" }
const _hoisted_15 = {
  id: "exA",
  class: "table table-striped table-bordered nowrap w-100"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Credit"),
    /*#__PURE__*/_createElementVNode("th", null, "Debit"),
    /*#__PURE__*/_createElementVNode("th", null, "Balance")
  ])
], -1))
const _hoisted_17 = ["data-transId", "id"]
const _hoisted_18 = { class: "exA" }
const _hoisted_19 = { class: "desc_td" }
const _hoisted_20 = { class: "exA" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "exA" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "exA" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_acq_basic = _resolveComponent("acq_basic")!

  return (_ctx.fum_id!='')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_acq_basic, {
          basic: _ctx.basic,
          fum_id: _ctx.fum_id
        }, null, 8, ["basic", "fum_id"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.acquisitions, (acq) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "main_securities",
                    key: acq.acq_id,
                    "data-acqId": acq.acq_id,
                    id: 'acq_'+acq.acq_id
                  }, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(acq.acq_date) + " - " + _toDisplayString(acq.acq_name), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(typeof acq.acq_amount!='undefined' ? acq.currency_symbol+' '+(acq.acq_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(typeof acq.acq_total_credit!='undefined' ? acq.currency_symbol+' '+(acq.acq_total_credit.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(typeof acq.acq_aum!='undefined' ? acq.currency_symbol+' '+(acq.acq_aum.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(typeof acq.acq_balance!='undefined' ? acq.currency_symbol+' '+(acq.acq_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(typeof acq.acq_profit!='undefined' ? acq.currency_symbol+' '+(acq.acq_profit.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1)
                  ], 8, _hoisted_6))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("table", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (trans) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "main_securities",
                    key: trans.trans_id,
                    "data-transId": trans.trans_id,
                    id: 'trans_'+trans.trans_id
                  }, [
                    _createElementVNode("td", _hoisted_18, _toDisplayString(trans.trans_date), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(trans.ref_description), 1),
                    _createElementVNode("td", _hoisted_20, [
                      (trans.trans_type==2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(typeof trans.trans_amount!='undefined' ? trans.currency_symbol+' '+(trans.trans_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      (trans.trans_type==1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(typeof trans.trans_amount!='undefined' ? trans.currency_symbol+' '+(trans.trans_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_24, _toDisplayString(typeof trans.trans_balance!='undefined' ? trans.currency_symbol+' '+(trans.trans_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1)
                  ], 8, _hoisted_17))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}